import React from 'react'

const HeadTitle = ({ imageSrc, text, description }) => {
  return (
    <div className="d-flex gap-16 align-items-center font-p">
    <span>
      <img src={imageSrc} className="img-fluid" alt="Dynamic" />
    </span>
    <div>
      <div className="fw-bold font-36 text-black font-p">{text}</div>
      <p>{description}</p>
    </div>
  </div>
  )
}

export default HeadTitle
